import {ENDPOINT_URL} from '../constants/index';
import {apiErrorHandling} from '../utils/apiUtils';

import getFetchOptions from '../utils/getFetchOptions';

export default function sendInvoice(invoice) {
	return fetch(
		`${ENDPOINT_URL}/createinvoice`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify({
				invoice,
			}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
